/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EditorGenerateRequest } from '../models/EditorGenerateRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AiEditorService {

    /**
     * Quick
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static quickApiV1EditorQuickPost(
        requestBody: EditorGenerateRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/editor/quick',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Generate
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static generateApiV1EditorGeneratePost(
        requestBody: EditorGenerateRequest,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/editor/generate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Generation Status
     * @param taskId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getGenerationStatusApiV1EditorGenerateTaskIdGet(
        taskId: string,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/editor/generate/{task_id}',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
